import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addPostViewApi } from "../../api/ClientActions";

interface PostViewState {
  loading: boolean;
  error: string | null;
  lastViewedPostId: number | null;
}

const initialState: PostViewState = {
  loading: false,
  error: null,
  lastViewedPostId: null,
};

export const addPostView = createAsyncThunk(
  "postView/addPostView",
  async (payload: any, { rejectWithValue }) => {
    const res = await addPostViewApi(payload);

    if (res?.success === false || res?.status === false) {
      return rejectWithValue(res?.message || "Failed to add post view");
    }

    return {
      ...payload,
      success: res?.success ?? res?.status ?? true,
      message: res?.message || "Post view added successfully",
    };
  }
);

const postViewSlice = createSlice({
  name: "postView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addPostView.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPostView.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.lastViewedPostId = Number(action.payload?.post_id || null);
      })
      .addCase(addPostView.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || "Failed to add post view";
      });
  },
});

export default postViewSlice.reducer;